import { connect } from 'react-redux';
import {
  fetchRecentlyViewedSpaces,
  toggleStarSpace,
} from '@core/spaceSelector/operations';
import { getCurrentUser } from '@core/utils/currentUser';
import { getCurrentSpace } from '@core/selectors/space';
import { isInstructor } from '@core/selectors/classroom';
import { RecentlyViewedSpaces } from './RecentlyViewedSpaces';
import { MY_SPACE_PAGE_RECENTLY_VIEWED_SECTION } from '@core/constants/analytics';

const mapStateToProps = (state) => {
  const user = getCurrentUser();
  return {
    recentlyViewedSpaceList:
      state?.spaceSelector?.recentlyViewedSpaces?.spaceList,
    user,
    space: getCurrentSpace(state),
    isEducator: isInstructor(state, user?.objectId) || false,
    isStaff: user?.userRoles?.includes('staff') || false,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onfetchRecentlyViewedSpaces: () => dispatch(fetchRecentlyViewedSpaces()),
    onSpaceStar: async ({
      spaceId,
      showArchived,
      sort,
      search,
      category,
      subCategory,
    }) => {
      await dispatch(
        toggleStarSpace({
          spaceId,
          search,
          sort,
          showArchived,
          category,
          subCategory,
          itemType: MY_SPACE_PAGE_RECENTLY_VIEWED_SECTION,
        })
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentlyViewedSpaces);
